import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  isLoading: false,
  genericHolidayTableData: {
    head: [],
    body: []
  },
  holidayUploadStatus: [],
  isHolidayUploadLoading:false
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    
    case types.LOADING_GENERICHOLIDAY:
      return {
        ...state,
        isLoading: action.data
      }
      case types.LOADING_GENERICHOLIDAY_STATUS:
        return {
          ...state,
          isHolidayUploadLoading: action.data
        }
        case types.GET_GENERICHOLIDAY_STATUS:
          return {
            ...state,
            holidayUploadStatus: action.data
          }
        case types.FAIL_GENERICHOLIDAY_STATUS:
            return {
              ...state,
              holidayUploadStatus: action.data
            }
    case types.GET_GENERICHOLIDAY:
      var data = action.data.map(i => {
        return [i.description, i.date,{id:i.id}]
      })
      return {
        ...state,
        genericHolidayTableData: {
          head: [
            { label: "Description", align: "left", },
            { label: "Date", align: "left"},
            { label: "Action", align: "right", },
           ],
          body: data
        },
      }
    case types.FAIL_GENERICHOLIDAY:
      return {
        ...state,
        genericHolidayTableData: {
          head: [],
          body: []
        }
      }
  
    default:
      return state
  }

}
export default reducer
